export class CustomFieldModel{
    public crmUserId:number;
    public sessionToken:string;
    public name:string;
    public description:string;
    public defaultValue:string;
    public fieldId:number;
    public newDescription:string;
}